export default "__VITE_ASSET__Cjgdohiw__"